import * as THREE from "three";
import gsap from "gsap";

import heroFieldVertexShader from "../shaders/heroField.vert?raw";
import heroFieldFragmentShader from "../shaders/heroField.frag?raw";

import { SCENE_STATES } from "../data/sceneStates.js";

export class HeroField {
  constructor({ profile }) {
    this.profile = profile;

    const geometry = new THREE.BufferGeometry();
    const count = profile.particleCount;
    const positions = new Float32Array(count * 3);
    const scales = new Float32Array(count);

    for (let index = 0; index < count; index += 1) {
      const i3 = index * 3;
      positions[i3 + 0] = (Math.random() - 0.5) * 12;
      positions[i3 + 1] = (Math.random() - 0.5) * 7;
      positions[i3 + 2] = (Math.random() - 0.5) * 7;
      scales[index] = 0.2 + Math.random() * 1.5;
    }

    geometry.setAttribute("position", new THREE.BufferAttribute(positions, 3));
    geometry.setAttribute("aScale", new THREE.BufferAttribute(scales, 1));

    this.material = new THREE.ShaderMaterial({
      vertexShader: heroFieldVertexShader,
      fragmentShader: heroFieldFragmentShader,
      transparent: true,
      depthWrite: false,
      blending: THREE.AdditiveBlending,
      uniforms: {
        uTime: { value: 0 },
        uPointSize: { value: profile.isMobile ? 34 : 46 },
        uIntensity: { value: 1.0 },
        uColorA: { value: new THREE.Color("#45d8ff") },
        uColorB: { value: new THREE.Color("#ffe083") }
      }
    });

    this.points = new THREE.Points(geometry, this.material);
  }

  transitionTo(state) {
    let intensity = 0.92;

    if (state === SCENE_STATES.INTRO) intensity = 1.3;
    if (state === SCENE_STATES.PROJECTS) intensity = 1.05;
    if (state === SCENE_STATES.CONTACT) intensity = 0.88;
    if (state === SCENE_STATES.LEGAL) intensity = 0.66;

    gsap.to(this.material.uniforms.uIntensity, {
      value: intensity,
      duration: 0.8,
      ease: "power2.out"
    });
  }

  update(elapsed) {
    this.material.uniforms.uTime.value = elapsed;
  }

  dispose() {
    this.points.geometry.dispose();
    this.material.dispose();
  }
}
